import { Injectable } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { Observable } from 'rxjs';
import { API } from './api';
import { ShowyePageApiPath, ShowyePageApiService, ShowyePageUtilService } from '@showye/showye-page-base';

@Injectable({
  providedIn: 'root',
})
/**
 * 接口服务，专用从服务器请求数据。缓存管理也在这里进行。
 *
 *
 */
export class NbApiService extends ShowyePageApiService {
  constructor(protected baseApi: ShowyePageApiPath, private api: API, protected http: _HttpClient, protected coder: ShowyePageUtilService) {
    super(baseApi, http, coder);
  }

  public domainTree(): Observable<any> {
    return this.http.get(this.api.DOMAIN_TREE);
  }

  public getSameLevelDomainList(id: any): Observable<any> {
    return this.http.get(this.api.GET_SAME_LEVEL_DOMAIN_LIST(id));
  }

  public roleList(param: any): Observable<any> {
    return this.http.post(this.api.ROLE_LIST, param);
  }

  public roleAdd(param: any): Observable<any> {
    return this.http.post(this.api.ROLE_ADD, param);
  }

  public roleInfo(id: any): Observable<any> {
    return this.http.get(this.api.ROLE_INFO(id));
  }

  public roleEdit(param: any): Observable<any> {
    return this.http.post(this.api.ROLE_EDIT, param);
  }

  public roleDelete(id: any): Observable<any> {
    return this.http.delete(this.api.ROLE_DELETE(id));
  }

  public roleConfig(param: any): Observable<any> {
    return this.http.post(this.api.ROLE_CONFIG, param);
  }

  public allRoles(): Observable<any> {
    return this.http.get(this.api.ALL_ROLES);
  }

  public getRoleListByDomainId(domainId: any, param: any): Observable<any> {
    return this.http.post(this.api.GET_ROLE_LIST_BY_DOMAIN(domainId), param);
  }

  public menuTree(): Observable<any> {
    return this.http.get(this.api.MENU_TREE);
  }

  public showMenuTree(): Observable<any> {
    return this.http.get(this.api.SHOW_MENU_TREE);
  }

  public myperms(): Observable<any> {
    return this.http.get(this.api.MY_PERMS);
  }

  public myshowperms(): Observable<any> {
    return this.http.get(this.api.MY_SHOW_PERMS);
  }

  public menuDelete(param: any): Observable<any> {
    return this.http.post(this.api.MENU_DELETE, param);
  }

  public buttonTree(): Observable<any> {
    return this.http.get(this.api.BUTTON_TREE);
  }

  public buttonAdd(param: any): Observable<any> {
    return this.http.post(this.api.BUTTON_ADD, param);
  }

  public buttonEdit(param: any): Observable<any> {
    return this.http.post(this.api.BUTTON_EDIT, param);
  }

  public buttonDelete(id: any): Observable<any> {
    return this.http.delete(this.api.BUTTON_DELETE(id));
  }

  // 枚举字典相关
  public enumList(par: any): Observable<any> {
    return this.http.post(this.api.ENUM_LIST, par);
  }

  // 权限组列表
  public authGroupList(): Observable<any> {
    return this.http.get(this.api.AUTH_GROUP_LIST);
  }

  // 权限组新增
  public authGroupAdd(par: any): Observable<any> {
    return this.http.post(this.api.AUTH_GROUP_ADD, par);
  }

  // 权限组编辑
  public authGroupEdit(par: any): Observable<any> {
    return this.http.post(this.api.AUTH_GROUP_EDIT, par);
  }

  // 权限组删除
  public authGroupDelete(id: any): Observable<any> {
    return this.http.delete(this.api.AUTH_GROUP_DELETE(id));
  }

  public addConfig(par: any): Observable<any> {
    return this.http.post(this.api.ADD_CONFIG, par);
  }

  public configTypes(): Observable<any> {
    return this.http.get(this.api.CONFIG_TYPES);
  }

  // 根据主体和部门用户列表下拉选择
  public getUserListByParam(par: any): Observable<any> {
    return this.http.post(this.api.GET_USER_LIST, par);
  }

  public getUserListByDomain(domainId: any, par: any): Observable<any> {
    return this.http.post(this.api.GET_USER_LIST_BY_DOMAIN(domainId), par);
  }

  // 用户列表
  public userList(par: any): Observable<any> {
    return this.http.post(this.api.USER_LIST, par);
  }

  // 新增用户
  public addUser(par: any): Observable<any> {
    return this.http.post(this.api.ADD_USER, par);
  }

  // 新增ott用户
  public addOTTUser(par: any): Observable<any> {
    return this.http.post(this.api.ADD_OTT_USER, par);
  }

  // 编辑用户
  public editUser(par: any): Observable<any> {
    return this.http.post(this.api.EDIT_USER, par);
  }

  public editAvatar(par: any): Observable<any> {
    return this.http.post(this.api.EDIT_AVATAR, par);
  }

  // 删除用户
  public deleteUser(id: any): Observable<any> {
    return this.http.delete(this.api.DELETE_USER(id));
  }

  public initPwd(id: any): Observable<any> {
    return this.http.get(this.api.INIT_PWD(id));
  }
  // 启用用户
  public userEnable(id: any): Observable<any> {
    return this.http.get(this.api.USER_ENABLE(id));
  }
  // 停用用户
  public userDisable(id: any): Observable<any> {
    return this.http.get(this.api.USER_DISABLE(id));
  }
  // 查看用户详情
  public userInfo(id: any): Observable<any> {
    return this.http.get(this.api.USER_INFO(id));
  }

  // 修改密码
  public changeMyPassword(param: any): Observable<any> {
    return this.http.post(this.api.MY_CHANGE_PASSWORD, param);
  }

  // 修改密码-没有登录
  public changePassword(param: any): Observable<any> {
    return this.http.post(this.api.NO_LOGIN_CHANGE_PASSWORD, param);
  }

  // 修改密码超期天数
  public changePasswordDay(param: any): Observable<any> {
    return this.http.post(this.api.DAY_PASSWORD, param);
  }

  // 修改修改容量阀值
  public changeLogThreshold(param: any): Observable<any> {
    return this.http.post(this.api.LOG_THRESHOLD, param);
  }

  // 判断是不是超过容量阀值
  public getLogThreshold(): Observable<any> {
    return this.http.get(this.api.LOG_THRESHOLD_INFO);
  }

  // 审计日志--进行审计
  public onChangeCheckLog(id: any): Observable<any> {
    return this.http.post(this.api.LOG_THRESHOLD_CHECK(id));
  }

  public database(): Observable<any> {
    return this.http.get(this.api.DATA_BASE);
  }

  public data(): Observable<any> {
    return this.http.get(this.api.DATA_BASE_DATA);
  }

  public listLog(param: any): Observable<any> {
    return this.http.post(this.api.LIST_LOG, param);
  }

  public getImgCode(): Observable<any> {
    return this.http.get(this.api.CAPTCHA_IMAGE);
  }

  public getBoardDeviceList(): Observable<any> {
    return this.http.get(this.api.GET_BOARD_DEVICE_LIST);
  }

  public playList(par: any): Observable<any> {
    return this.http.post(this.api.PLAY_LIST, par);
  }
  public addPlay(par: any): Observable<any> {
    return this.http.post(this.api.ADD_PLAY, par);
  }
  public addPlayDetail(par: any): Observable<any> {
    return this.http.post(this.api.ADD_PLAY_DETAIL, par);
  }

  public editPlayDetail(par: any): Observable<any> {
    return this.http.post(this.api.EDIT_PLAY_DETAIL, par);
  }

  public playInfo(id: any): Observable<any> {
    return this.http.get(this.api.PLAY_INFO(id));
  }
  public delPlayDetail(detailId: any): Observable<any> {
    return this.http.post(this.api.DEL_PLAY_DETAIL(detailId));
  }
  public delPlayDetailByItemId(itemId: any): Observable<any> {
    return this.http.post(this.api.DEL_PLAY_DETAIL_BY_ITEM_ID(itemId));
  }
  public play(par: any): Observable<any> {
    return this.http.post(this.api.PLAY, par);
  }

  public delPlay(id: any): Observable<any> {
    return this.http.post(this.api.DEL_PLAY(id));
  }

  public approvedAudit(id: any, par: any): Observable<any> {
    return this.http.get(this.api.APPROVED_AUDIT(id), par);
  }

  public rejectAudit(id: any, par: any): Observable<any> {
    return this.http.get(this.api.REJECT_AUDIT(id), par);
  }

  public submitAudit(id: any): Observable<any> {
    return this.http.get(this.api.SUBMIT_AUDIT(id));
  }

  public screenshot(id: any): Observable<Blob> {
    return this.http.post(this.api.SCREEN_SHOT(id), { responseType: 'blob' });
  }

  public clearBoard(id: any): Observable<any> {
    return this.http.post(this.api.CLEAR_BOARD(id));
  }

  public getBrightness(id: any): Observable<any> {
    return this.http.post(this.api.GET_BRIGHTNESS(id));
  }

  public getBrightnessByTimeList(id: any): Observable<any> {
    return this.http.post(this.api.get_Brightness_By_Time_List(id));
  }

  public getBrightnessAuto(id: any): Observable<any> {
    return this.http.post(this.api.GET_BRIGHTNESS_AUTO(id));
  }

  public setBrightness(par: any): Observable<any> {
    return this.http.post(this.api.SET_BRIGHT_NESS, par);
  }

  public setBrightnessByTimeList(par: any): Observable<any> {
    return this.http.post(this.api.SET_BRIGHTNESS_BY_TIME_LIST, par);
  }

  public setBrightnessAuto(par: any): Observable<any> {
    return this.http.post(this.api.SET_BRIGHTNESS_AUTO, par);
  }

  public timeZoneList(): Observable<any> {
    return this.http.get(this.api.TIME_ZONE_LIST);
  }

  public getTimeAndTimeZone(id: any): Observable<any> {
    return this.http.post(this.api.GET_TIME_AND_TIME_ZONE(id));
  }

  public setTimeAndTimeZone(par: any): Observable<any> {
    return this.http.post(this.api.SET_TIME_AND_TIME_ZONE, par);
  }

  public getDeviceVolume(par: any): Observable<any> {
    return this.http.post(this.api.GET_DEVICE_VOLUME, par);
  }

  public setDeviceVolume(par: any): Observable<any> {
    return this.http.post(this.api.SET_DEVICE_VOLUME, par);
  }
  public getScreenStatus(id: any): Observable<any> {
    return this.http.post(this.api.GET_SCREEN_STATUS(id));
  }
  public setPower(par: any): Observable<any> {
    return this.http.post(this.api.SET_POWER, par);
  }
  public getDevicePowerByTimeList(id: any): Observable<any> {
    return this.http.post(this.api.GET_DEVICE_POWER_BY_TIME_LIST(id));
  }
  public setDevicePowerByTimeList(par: any): Observable<any> {
    return this.http.post(this.api.SET_DEVICE_POWER_BY_TIME_LIST, par);
  }
  public getDeviceSize(par: any): Observable<any> {
    return this.http.post(this.api.GET_DEVICE_SIZE, par);
  }

  public getSystemInfo(id: any): Observable<any> {
    return this.http.get(this.api.GET_SYSTEM_INFO(id));
  }

  public setPlayByTimeList(par: any): Observable<any> {
    return this.http.post(this.api.SET_PLAY_BY_TIME_LIST, par);
  }

  public getPlayByTimeList(id: any): Observable<any> {
    return this.http.post(this.api.GET_PLAY_BY_TIME_LIST(id));
  }

  public getAllPlaylistId(id: any): Observable<any> {
    return this.http.get(this.api.GET_ALL_PLAY_LIST_ID(id));
  }

  public startPlayOfBoard(par: any): Observable<any> {
    return this.http.post(this.api.START_PLAY_OF_BOARD, par);
  }

  public delPlayOfBoard(par: any): Observable<any> {
    return this.http.post(this.api.DEL_PLAY_OF_BOARD, par);
  }

  public batchDelPlayOfBoard(par: any): Observable<any> {
    return this.http.post(this.api.BATCH_DEL_PLAY_OF_BOARD, par);
  }

  public sensitiveList(par: any): Observable<any> {
    return this.http.post(this.api.SENSITIVE_LIST, par);
  }

  public enableSensitive(): Observable<any> {
    return this.http.get(this.api.ENABLE_SENSITIVE);
  }

  public disabledSensitive(): Observable<any> {
    return this.http.get(this.api.DISABLED_SENSITIVE);
  }

  public deleteSensitive(par: any): Observable<any> {
    return this.http.post(this.api.DELETE_SENSITIVE, par);
  }

  public editSensitive(par: any): Observable<any> {
    return this.http.post(this.api.edit_sensitive, par);
  }

  public addSensitive(par: any): Observable<any> {
    return this.http.post(this.api.ADD_SENSITIVE, par);
  }
}
